import React from 'react'
import { Switch } from 'antd'
import { useStore } from '../../store/store'
import { isAVariableBox } from '../../utils/boxes'
import './HideInFormSwitcher.css'

const HideInFormSwitcher = ({ boxId, variant = 'dark' }) => {
  const box = useStore(({ boxes, }) => boxes.find((b) => b.id === boxId))
  const isTemplate = useStore(({ currentDocument }) => currentDocument.type === 'template')
  const boxVariableSwitcher = useStore(({ boxVariableSwitcher }) => boxVariableSwitcher)
  const boxHideInFormSwitcher = useStore(({ boxHideInFormSwitcher }) => boxHideInFormSwitcher)

  if (!isTemplate || !box) return null

  const isPanel = variant === 'panel'

  return (
    <div data-outside-ignore="true" style={{
      display: 'flex',
      marginRight: isPanel ? 0 : 30,
      width: isPanel ? '100%' : undefined,
      justifyContent: isPanel ? 'space-between' : undefined,
      alignItems: 'center',
      color: isPanel ? 'inherit' : 'white',
      gap: '8px'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: isPanel ? 'row' : 'column',
        lineHeight: '1.2'
      }}>
        {isPanel
          ? <span>Afficher dans le formulaire</span>
          : <><span style={{ textAlign: 'end' }}>Afficher dans</span>
            <span style={{ textAlign: 'end' }}>le formulaire</span></>}
      </div>
      <Switch
        className="custom-switch"
        style={{ width: '44px' }}
        onMouseDown={(e) => e.preventDefault()}
        checked={isAVariableBox(box.type) && !box.hideInForm}
        checkedChildren={<i className="fa-solid fa-check" style={{ color: 'white', fontSize: '12px', position: 'relative', top: '1px', left: '-1px' }} />}
        unCheckedChildren={<i className="fa-solid fa-xmark" style={{ color: 'white', fontSize: '13px', position: 'relative', top: '1px', left: '-1px' }} />}
        onChange={() => {
          if (!isAVariableBox(box.type))
            boxVariableSwitcher(box.id)
          else
            boxHideInFormSwitcher(box.id)
        }}
      />
    </div>
  )
}

export default HideInFormSwitcher
